<template>
	<div>
		<v-card v-if="selectedDataPoint">
			<v-card-title>
				<translate>Dashboard</translate>
			</v-card-title>
			<v-card-text>
				<v-row v-if="dataPoints.length > 1">
					<v-col cols="auto">
						<v-select
							v-model="selectedDataPoint"
							:items="dataPoints"
							item-title="name"
							return-object
						/>
					</v-col>
				</v-row>
				<v-row>
					<v-col
						v-for="(item, index) in displayDataPoint"
						:key="index"
						cols="4"
					>
						<v-card>
							<v-card-title>{{ cleanupIndex(index) }}</v-card-title>
							<v-card-text class="text-center">
								<h1>
									{{ item }}
								</h1>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions>
				<v-col>
					<v-btn
						color="primary"
					>
						<translate>Export to csv</translate>
					</v-btn>
				</v-col>
			</v-card-actions>
		</v-card>
		<div v-else>
			<translate>No data points found</translate>
		</div>
	</div>
</template>
<script>
import {
	axios,
} from '../../../services/axios-service';
import {
	displayError,
} from 'laravel-front-library';
import {
	toRaw,
} from 'vue';

export default {
	name: 'ResellerDashboard',
	data () {
		return {
			selectedDataPoint: null,
			dataPoints: [],
		};
	},

	computed: {
		displayDataPoint () {
			if (this.selectedDataPoint) {
				const datapoint = structuredClone(toRaw(this.selectedDataPoint));

				delete datapoint.name;
				return datapoint;
			}
			return [];
		},
	},

	created () {
		this.getDataPoints();
	},
	methods: {
		/**
		 * Retrieve data points from the backend
		 */
		getDataPoints () {
			axios.get('/resellers/dashboard/data/')
				.then(({
					data: data
				}) => {
					this.dataPoints = data;
					this.selectedDataPoint = this.dataPoints[0];
				})
				.catch(() => {
					displayError(this.$gettext('Something has gone wrong during status request'));
				});
		},

		/**
		 * Capitalize first letter and add spaces
		 *
		 * @param {string} index
		 * @returns {string} formal index
		 */
		cleanupIndex (index) {
			const formalIndex = index.replace(/([A-Z])/g, ' $1').trim();

			return this.$gettext(formalIndex.charAt(0).toUpperCase() + formalIndex.slice(1).toLowerCase());
		}
	}
};
</script>
